import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule, NoopAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgChartsModule } from 'ng2-charts';
import { AgGridModule } from 'ag-grid-angular';
import { NgSelectModule } from '@ng-select/ng-select';
import { ToastrModule } from 'ngx-toastr';

import { AppComponent } from './app.component';
import { LoginComponent } from './components/auth/login/login.component';
import { SidebarComponent } from './components/layout/main-layout/sidebar/sidebar.component';
import { ContactUsModalComponent } from './components/common/contact-us-popover/contact-us-popover.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { ForgotPasswordComponent } from './components/auth/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './components/auth/reset-password/reset-password.component';
import { LoginLayoutComponent } from './components/layout/login-layout/login-layout.component';
import { MainLayoutComponent } from './components/layout/main-layout/main-layout.component';
import { PageNotFoundComponent } from './components/common/page-not-found/page-not-found.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { DropZoneDirective } from './directives/dropzone.directive';
import { AccountComponent } from './components/account/account.component';
import { EarlyAccessSubscribeModalComponent } from './components/common/subscribe-modal/subscribe-modal.component';
import { DashboardBlogComponent } from './components/dashboard/blog/blog.component';
import { AuthHttpInterceptor } from './interceptors/auth-http-interceptor';
import { OwlModule } from 'ngx-owl-carousel';
import { DateRangePickerComponent } from './components/common/date-range-picker/date-range-picker.component';
import { ReportsComponent } from './components/reports/reports.component';
import { NewReportComponent } from './components/reports/new-report/new-report.component';
import { LookupProductsCollectionComponent } from './components/reports/new-report/lookup-products/product-collection/product-collection.component';
import { NewReportHistoricalDataComponent } from './components/reports/new-report/common/historical-data/historical-data.component';
import { UploadProductDetailsComponent } from './components/reports/new-report/upload-products-list/product-details/product-details.component';
import { UpdateReportNameModalComponent } from './components/reports/update-report-name-modal/update-report-name-modal.component';
import { DeleteReportModalComponent } from './components/reports/delete-report-modal/delete-report-modal.component';
import { LookupProductsCollectionBrandsDropdownComponent } from './components/reports/new-report/lookup-products/product-collection/brands-dropdown/brands-dropdown.component';
import { UploadProductsListComponent } from './components/reports/new-report/upload-products-list/upload-products-list.component';
import { LookupProductsComponent } from './components/reports/new-report/lookup-products/lookup-products.component';
import { LookupProductsDetailsComponent } from './components/reports/new-report/lookup-products/product-details/product-details.component';
import { ProductsAttributesDropdownComponent } from './components/reports/new-report/common/attributes-dropdown/attributes-dropdown.component';

@NgModule({
  declarations: [
    AppComponent,
    DropZoneDirective,
    LoginComponent,
    SidebarComponent,
    ContactUsModalComponent,
    DashboardComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    LoginLayoutComponent,
    MainLayoutComponent,
    PageNotFoundComponent,
    AccountComponent,
    EarlyAccessSubscribeModalComponent,
    DashboardBlogComponent,
    DateRangePickerComponent,
    ReportsComponent,
    NewReportComponent,
    LookupProductsCollectionComponent,
    NewReportHistoricalDataComponent,
    UpdateReportNameModalComponent,
    DeleteReportModalComponent,
    LookupProductsCollectionBrandsDropdownComponent,
    UploadProductsListComponent,
    LookupProductsComponent,
    LookupProductsDetailsComponent,
    UploadProductDetailsComponent,
    ProductsAttributesDropdownComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    NgbModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgChartsModule,
    AgGridModule,
    NgSelectModule,
    ToastrModule.forRoot({
      timeOut: 5000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
      newestOnTop: true,
      progressBar: true
    }),
    NoopAnimationsModule,
    OwlModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthHttpInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
